import script from "./NewsPageBodyNewsfeedItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageBodyNewsfeedItem.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageBodyNewsfeedItem.vue?vue&type=style&index=0&id=b44d2e64&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b44d2e64"]])

export default __exports__